module.exports = __webpack_public_path__ + "img/IMG_0057_L_Black_MockedUp.9ba520e4.jpg";